// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj, generateHeaders } from '..'
import { vcBaseUrl } from '.'


export interface PromoRequirements {
    groupSpend?: number
    participantCount?: number
}

export interface UserCredit {
    id: string
    promoId: string
    type: string
    action: string
    amount: number
    createdAt: string
    updatedAt: string
    claimedAt: string
    requirements?: PromoRequirements
}

export type UserCreditsResponse = (SuccessResponse & {
    credits: UserCredit[]
}) | FailedResponse

export class GetUserCreditsRequest extends Request {
    private constructor(userId: string, init?: RequestInit) {
        super(`${vcBaseUrl}/user/${userId}/credits`, init)
    }

    static async init(userId: string, init?: RequestInit) {
        return new GetUserCreditsRequest(userId, {
            ...init,
            method: 'GET',
            headers: await generateHeaders('Clerk-Token', init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<UserCreditsResponse> {
        const response = await fetch(this)
        const data = createResponseObj<UserCreditsResponse>(await response.json())
        console.info('Get User Credits Response:', data)

        switch (data.status) {
            case 'successful': return data
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
